import { render, staticRenderFns } from "./appointmentWithdrawal.vue?vue&type=template&id=6bffb114&scoped=true"
import script from "./appointmentWithdrawal.vue?vue&type=script&lang=js"
export * from "./appointmentWithdrawal.vue?vue&type=script&lang=js"
import style0 from "./appointmentWithdrawal.vue?vue&type=style&index=0&id=6bffb114&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bffb114",
  null
  
)

export default component.exports